import { Transformer } from '@is24at/react-transformers';
import { buildPrettyUrlFromAccount } from 'core/prettyUrlsExpose';
import { logoUrl as imageUrl } from 'core/transformers';
import title from './htmlMetaTransformers/title';
import description from './htmlMetaTransformers/description';

const exposeHtmlMetaTransformer = (expose: any) =>
  new Transformer({
    title,
    description,
    imageUrl,
    canonicalUrl: buildPrettyUrlFromAccount,
  }).transform(expose);

export default exposeHtmlMetaTransformer;
